import script from "./SystemGroupItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SystemGroupItem.vue?vue&type=script&lang=ts&setup=true"

import "./SystemGroupItem.vue?vue&type=style&index=0&id=1638b9be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1638b9be"]])

export default __exports__